<template>
  <div>
    <CRow>
      <CCol sm="12">
        <CRow class="search-panel">
          <CCol sm="3" xs="12">
            <div style="position: relative;">
              <BaseInput
                :options="queueNameInput.options"
                :data="queueNameInput.data"
                :listener="queueNameInput.listener"
              />
            </div>
          </CCol>
          <CCol>
            <div class="form-group">
              <label style="color: white"></label>
              <CButton
                color="primary" ref="refreshBtn"
                v-c-tooltip.hover="'Refresh'"
                class="btn-action-primary"
                @click="loadDataMainTable"
                style="float: right;"
              >
                <i class="fa fa-refresh"></i>&nbsp;Refresh
              </CButton>
            </div>
          </CCol>
        </CRow>
        <CCard class="mt-3p5 content-fade-in">
          <CCardBody>
            <BaseTable
              :options="mainTable.options"
              :slots="mainTable.slots"
              :dataSource="mainTable.dataSource"
              ref="mainTable"
            >
              <template #index="{index}">
                <td>
                  <span>{{
                      $refs.mainTable.getTotalElementByPage + index
                    }}</span>
                </td>
              </template>
              <template slot="name" slot-scope="data">
                <td>
                  <span style="font-weight: 550;">{{ data.item.name }}</span>
                </td>
              </template>

              <template #size="{item}">
                <td>
                  <CBadge v-if="item.size == 0" color="success">{{ item.size }}</CBadge>
                  <CBadge v-else-if="item.size < 100" color="info">{{ item.size }}</CBadge>
                  <CBadge v-else-if="item.size < 500" color="warning">{{ item.size }}</CBadge>
                  <CBadge v-else color="danger">{{ item.size }}</CBadge>
                </td>
              </template>

              <template #action="{item}">
                <td class="group-action">
                  <CButton
                    color="warning"
                    @click="setupQueueAction('reset_one', item.name)">
                    <i class="fa fa-refresh mr-1"></i>Reset
                  </CButton>
                  <!-- <span v-else style="color: #28a745;">Đã trống</span> -->
                </td>
              </template>
            </BaseTable>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
    <ModalConfirm
      :actionTypeMapping="actionData.actionTypeMapping"
      ref="actionModal"
    >
    </ModalConfirm>
  </div>
</template>

<script>
import BaseTable from "../base/BaseDataTable";
import BaseInput from "../base/BaseInput";
import ModalConfirm from "../base/BaseModalConfirm";

export default {
  name: "QueueList",
  components: {BaseTable, BaseInput, ModalConfirm},
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success"
    },
    showErrorMsg: {
      type: "error",
      title: "Error"
    },
    showWarningMsg: {
      type: "warn",
      title: "warn"
    }
  },
  data() {
    var that = this;
    var actionTypeMapping = new Map();
    actionTypeMapping.set("reset_one", {
      url: "/queue/reset",
      isJsonContentType: false,
      titlePopup: function () {
        return that.$helper.setupTitleAction(
          "reset",
          "queue",
          that.actionData.model.queueSelectedName
        );
      },
      dataSubmit: function () {
        return {
          queueName: that.actionData.model.queueSelectedName
        };
      },
      successCallback: function () {
        that.showSuccessMsg({
          message: "Reset queue thành công"
        });
        that.loadDataMainTable();
      }
    });

    return {
      queueNameInput: {
        options: {
          type: "text",
          placeholder: "Tên queue",
          label: "Tên queue"
        },
        data: {
          name: "queueName",
          model: "",
          updateTrigger: function () {
            return that.$refs.mainTable;
          }
        }
      },
      actionData: {
        actionTypeMapping: actionTypeMapping,
        model: {
          queueSelectedName: null
        }
      },
      mainTable: {
        options: {
          noPaging: true,
          fields: [
            {key: "index", label: "STT"},
            {key: "name", label: "Tên Queue"},
            {key: "size", label: "Size"},
            {key: "action", label: "Action"}
          ],
          slots: ["index", "name", "size", "action"]
        },
        dataSource: {
          url: "/queue/list",
          isJsonContentType: false,
          dataRef: function () {
            return that.$data;
          },
          response: function (dataResponse) {
            return dataResponse.data;
          },
          btnCallAjaxs: function () {
            return [that.$refs.refreshBtn]
          },
          resultListAttrName: "queues"
        }
      }
    };
  },
  methods: {
    loadDataMainTable: function () {
      this.$refs.mainTable.loadData();
    },
    setupQueueAction: function (actionTypeKey, queueSelectedName) {
      this.actionData.model.queueSelectedName = queueSelectedName || null;
      this.$refs.actionModal.setCurrAction(actionTypeKey);
    }
  },
  computed: {},
  beforeCreate: function () {
  },
  created: function () {
  },
  mounted() {
  },
  watch: {}
};
</script>
<style scoped></style>

